import React from 'react';
import { isAdminArea, isAdminRegional } from '../../utils/adminMenu';
import AdminAreaMenuOptions from './AdminAreaMenuOptions';
import AdminGeneralMenuOptions from './AdminGeneralMenuOptions';
import AdminRegionalMenuOptions from './AdminRegionalMenuOptions';

const AdminRoleMenuOptions = ({ user, ...props }) => {
  if (isAdminArea(user)) {
    return <AdminAreaMenuOptions user={user} {...props} />;
  }

  if (isAdminRegional(user)) {
    return <AdminRegionalMenuOptions user={user} {...props} />;
  }

  return <AdminGeneralMenuOptions user={user} {...props} />;
};

export default AdminRoleMenuOptions;
